import type { FaireProductEntity } from "../../entity_types/product";

export const p_9cxlauo4jw: FaireProductEntity = {
  token: "p_9cxlauo4jw",
  type: "product",
  name: "Earth Mama Lip Balm",
  brandToken: "b_1q5xt82q",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/208169e74586409f516377394fa808fc90732ff2fdb66a19d03e16ae12047419.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a5ff1546d286cc77889a8166ee6363431c00cd078a96b911acf32cb1a17d7592.jpeg",
    "https://cdn.faire.com/fastly/28a6b3cb4c7d33eb0f783f7d41843d86f0690dc1591b9b7ccfc057d8bf9cdb6e.jpeg",
    "https://cdn.faire.com/fastly/9e09f09750372bd458259ac02db15c3e8f13c29ebd1ee0ffce8d8cbeada78b5c.jpeg",
    "https://cdn.faire.com/fastly/d009ad6d1ff85e30d7de6d110ea5fe226df5d629c950be03def6460fbf423ef1.jpeg",
    "https://cdn.faire.com/fastly/9491b07d96e5e31f5ae6fdc37f563fde6e40a558872c884055396fd917acc07b.jpeg",
    "https://cdn.faire.com/fastly/8a34fb157b00f7f5e5ec8af0445cf6d2ea3caa52fb12f59199341865f03e6c18.jpeg",
    "https://cdn.faire.com/fastly/e8eabec99ebfa73459aa3e33767dbc2ee8e031f3bc8a7e6748b8a996674718da.jpeg",
    "https://cdn.faire.com/fastly/e92493f9f8d7cf0675c95fad79450102030252b326da22f6154640831c2c7a99.jpeg",
    "https://cdn.faire.com/fastly/2238386eeaab9b0676a8bdd09ba42b6a14fffcdf7069ac12d8589e5dd6c85eb0.jpeg",
    "https://cdn.faire.com/fastly/72d43a5b8dad978da9e152ff342c0a8c5c0c695065b66c21449fa4723cd00309.jpeg",
  ],
  priceDollars: 2.76,
  description:
    "Meet your new favorite lip balm! Earth Mama’s Lip Balms, now in 100% plastic free containers, soothe and hydrate with organic herbs and oil formulations, in four different flavors. Coconut Smoothie, which blends coconut and vanilla for a tropical twist, Orange Ginger, a zingy mix of orange, ginger and a hint of mint, Lavender Meringue, a magical balance of lavender and vanilla and, and Mint Herbal, which is bright and refreshing with just the right amount of lip tingle. \n * No petrolatum, artificial preservatives, colors or flavors. \n * Certified by Oregon Tilth, Leaping Bunny Certified, and Plastic Free. \n * Formulated to be safe for the whole family, including kids, as well as pregnant and breastfeeding moms. \n * Available individually, or in a convenient quadruplet pack, featuring all four flavors in one. \n\n\n\n\n\n",
  tags: [],
  msrpDollars: 5.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:02.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
